/**
 * 이름 마스킹 (개인정보 보호)
 * - 1글자: 그대로 (김 → 김)
 * - 2글자: 마지막 글자 마스킹 (홍길 → 홍*)
 * - 3글자 이상: 처음·끝만 남기고 가운데 전부 마스킹, 공백은 유지
 *   (홍길동 → 홍*동, 남궁민수 → 남**수, Michael → M*****l, John Smith → J******* h)
 */
export function maskName(name?: string): string {
  const trimmed = (name ?? "").trim();
  if (!trimmed) return "";

  const chars = [...trimmed]; // 서로게이트 페어 안전
  const len = chars.length;

  if (len === 1) return trimmed;
  if (len === 2) return chars[0] + "*";

  const middle = chars
    .slice(1, -1)
    .map((c) => (c === " " ? " " : "*"))
    .join("");
  return chars[0] + middle + chars[len - 1];
}
